import { Component, OnInit } from '@angular/core';
import { ResidentialService } from '../questionarie-signup/questionnaire-residential/residential.service';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { environment } from '../../environments/environment';
import { _ } from 'underscore';
import { Title, Meta } from '@angular/platform-browser';
import { RecommendationService } from '../questionarie-signup/questionnaire-residential/recommendation/recommendation.service';
import 'rxjs/add/operator/pairwise';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  entryComponents: [SnackbarComponent],
})
export class LoginComponent implements OnInit {
  userObj = {
    emailId: '',
    password: '',
    phone: '',
  };
  url = environment.api_url;
  previousUrl = '';
  url1 = '';
  oldURL = '';
  forgotModalVisible = false;
  user_bot: boolean;
  invalidEmail = false;
  private loadNavigateByUrl = {
    faq: '/faq',
    precontact: '/faq/contact-us',
    privacypolicy: '/faq/privacy-policy',
    termsofservice: '/faq/terms-of-service',
    residential: '/',
    giveback: '/giveback',
    precontactmob: '/pre-contact',
    privacypolicymob: '/privacy-policy',
    termsofservicemob: '/terms-of-service',
    commercial: '/commercial',
    blog: '/blog',
  };
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    private residentialService: ResidentialService,
    private http: HttpClient,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private recommendationService: RecommendationService,
    private title: Title,
    private meta: Meta,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.activeRouter.queryParams.subscribe((params) => {
      this.previousUrl = params.returnUrl;
    });
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');

    this.title.setTitle('Login to your Honest Gorilla dashboard');

    this.meta.updateTag({
      name: 'keywords',
      content: 'login,honest gorilla,get started',
    });
    this.meta.updateTag({
      name: 'description',
      content:
        'Login to your Honest Gorilla dashboard to renew or choose a new energy plan, update your saved responses, or learn what special offers we have in store for you.',
    });
    this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
  }

  formatPhoneNumber(phoneNo: string): string {
    return `${phoneNo.slice(0, 3)}-${phoneNo.slice(3, 6)}-${phoneNo.slice(6)}`;
  }

  // create account
  createAccount(event, myForm) {
    this.invalidEmail = false;
    if (this.userObj.emailId == '') {
      this.invalidEmail = true;
      return false;
    }
    this.validateEmailOrPhone();
    this.userObj = { ...this.userObj, ...{ accountType: 'internal' } };
    const body = new HttpParams()
      .append('userObj', JSON.stringify(this.userObj))
      .append('a', 'login');
    this.http
      .get(this.url + '/login', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (result.statusCode === '001') {
          if (result.data.userRole === 'Admin') {
            this.title.setTitle('Admin Dashboard');
          }
          let questionnarieObj = sessionStorage.getItem('userResponse');
          let percentage = sessionStorage.getItem('percentage');
          if (questionnarieObj && result.data) {
            const body = new HttpParams()
              .append('questionnarieObj', questionnarieObj)
              .append('userObj', JSON.stringify(result.data))
              .append('percentage', percentage);
            this.http
              .post(this.url + '/saveQuestions', body)
              .subscribe((res: any) => {});
          }

          myForm.resetForm();

          // set the user obj in  localstorage to verify in quit flow.
          sessionStorage.setItem('userObj', JSON.stringify(result.data));
          this.oldURL = sessionStorage.getItem('path');
          sessionStorage.setItem('loginUserId', result.data.hg_accountId);
          // Check the user is admin user
          if (result.data.userRole === 'Admin') {
            // navigate to admin page
            this.router.navigate(['hg-admin']);
          } else {
            if (sessionStorage.getItem('signupProduct')) {
              this.router.navigate(['signuporder', result.data.hg_accountId]);
            } else if (this.oldURL) {
              // this.router.navigateByUrl(this.loadNavigateByUrl[this.oldURL]);
              if (this.oldURL === 'precontact') {
                this.router.navigateByUrl('/faq/contact-us');
              } else if (this.oldURL === 'commercial') {
                this.router.navigateByUrl('/commercial');
              } else if (this.oldURL === 'giveback') {
                this.router.navigateByUrl('/giveback');
              } else if (this.oldURL === 'blog') {
                this.router.navigateByUrl('/blog');
              } else if (this.oldURL === 'faq') {
                this.router.navigateByUrl('/faq');
              } else if (this.oldURL === '//') {
                this.router.navigateByUrl('/');
              } else {
                this.router.navigate([
                  'user-settings',
                  result.data.hg_accountId,
                ]);
              }
            } else {
              if (this.previousUrl) {
                this.router.navigateByUrl(this.previousUrl);
              } else {
                this.router.navigate([
                  'user-settings',
                  result.data.hg_accountId,
                ]);
              }
            }
            // Set the questionnarie username and accountId in local
            this.recommendationService.userName = result.data.questionStatusObj
              ? result.data.questionStatusObj.userName
                ? result.data.questionStatusObj.userName
                : null
              : null;
            localStorage.setItem(
              'userName',
              this.recommendationService.userName
                ? this.recommendationService.userName
                : result.data.userName
                ? result.data.userName
                : null
            );

            this.residentialService.setUser({
              userName: result.data.userName,
              accountId: result.data.hg_accountId,
              emailId: result.data.userDetails.emailId,
            });
            this.residentialService.userResponse.userResponses =
              result.data.userResponses;
            this.residentialService.questionnaireStatusObj =
              result.data.questionStatusObj;
            this.residentialService.filter(result.data.userResponses);
            try{
              this.residentialService.currentId =
              result.data.questionStatusObj.questionStep;
            this.residentialService.messageService({
              nextId: result.data.questionStatusObj.questionStep,
              questionStatus: result.data.questionStatusObj.questionStatus,
              responses: result.data.userResponses,
            });
            }catch
            {

            }
       
          }
        } else {
          this.openSnackBar(result.statusText);
          this.userObj.emailId = '';
          this.userObj.password = '';
        }
      });
  }

  validateEmailOrPhone() {
    if (this.userObj.emailId && this.userObj.emailId.indexOf('@') === -1) {
      this.userObj.phone = this.formatPhoneNumber(this.userObj.emailId);
      delete this.userObj.emailId;
    } else if (this.userObj.emailId.indexOf('@') > 1) {
      if (this.userObj.emailId === undefined)
        this.userObj.emailId = this.userObj.emailId;
      delete this.userObj.phone;
    }
  }

  openSnackBar(statusText) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 30000,
      data: {
        name: statusText,
        title: 'Error',
      },
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: 'bg-danger',
    });
  }

  closebtn() {
    window.history.back();
  }
  showForgotModal() {
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.forgotModalVisible = true;
  }
  onClose(isVisible: boolean) {
    this.forgotModalVisible = isVisible;
  }

  toggleShowPassword(password) {
    this.user_bot = !this.user_bot;
  }

  // handling the gmail authentication flow
  getAuthenticate(url) {
    // questionarie object
    const questionnarieObj = this.residentialService.userResponse;
    const questionStatusObj = sessionStorage.getItem('questionStatusObj');
    sessionStorage.setItem('questionStatusObj', questionStatusObj);
    sessionStorage.setItem('userResponse', JSON.stringify(questionnarieObj));

    const body = new HttpParams()
      .append('a', 'external')
      .append('questionnarieObj', JSON.stringify(questionnarieObj))
      .append('type', JSON.stringify('login'));

    this.http
      .post(this.url + '/getUserResponse', body)
      .subscribe((res: any) => {
        const result = res;
        window.location.href = environment.api_url + url;
      });
  }
}
